// @flow
import React, { Component } from "react";
import { push } from "connected-react-router/immutable";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Badge from "@material-ui/core/Badge";
import MaterialList from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Link from "@material-ui/core/Link";
import { List, Map } from "immutable";
import Breadcrumbs from "./Breadcrumbs";
// code split this because it contains huge WYSIWYG editor and CAPTCHA
import Loadable from "react-loadable";
import ICPCLoader from "components/ICPCLoader";
import EditableContent from "components/EditableContent";

const AddIssue = Loadable({
  loader: () => import("./AddIssue"),
  loading: ICPCLoader,
});

function PaddedSection(props: { children: any }) {
  return <section style={{ padding: 24 }}>{props.children}</section>;
}

function SearchContainer(props: {
  searchResults: ?List<Map<string, any>>,
  url: string,
  redirect: (string) => void,
}) {
  const { searchResults, url, redirect } = props;
  return (
    <MaterialList>
      {searchResults &&
        searchResults.map((result) => {
          return (
            <Card elevation={0} key={result.get("title")}>
              <CardContent>
                <Typography
                  variant="h5"
                  color="secondary"
                  component={Link}
                  onClick={() => redirect(`${url}/${result.get("key")}`)}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  {result.get("title")}
                </Typography>
                <div style={{ marginLeft: -15 }}>
                  <Breadcrumbs
                    color="secondary"
                    breadcrumbs={result.get("breadcrumbs")}
                    url={url}
                    redirect={redirect}
                  />
                </div>
                <div dangerouslySetInnerHTML={{ __html: result.get("hint") }} />
              </CardContent>
            </Card>
          );
        })}
    </MaterialList>
  );
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});

type Props = {
  classes: Object,
  topicKey: string,
  id: ?number,
  title: string,
  hint: string,
  selectedTab: 0 | 1 | 2,
  setTab: (number) => void,
  searchResults: ?List<Map<string, any>>,
  redirect: (string) => void,
  showMessage: (string) => void,
  url: string,
  isAdmin: Boolean,
  updateTopic: (string, Object) => void,
  addNewTopic: (string, Object) => void,
  match: Object,
};

class HelpContent extends Component<Props> {
  static defaultProps = {
    selectedTab: 0,
  };

  handleChange = (event, value) => {
    this.props.setTab(value);
  };

  updateTopic = (title: string, content: string) => {
    const { id, topicKey, updateTopic, isModal } = this.props;
    const topicDTO = {
      id: id,
      key: topicKey,
      title: title,
      hint: content,
    };
    updateTopic(topicKey, topicDTO, !isModal);
  };
  addNewTopic = (title: string) => {
    const { id, topicKey, addNewTopic } = this.props;
    const topicDTO = {
      id: id,
      key: topicKey,
      title: title,
      hint: "",
    };
    addNewTopic(topicKey, topicDTO);
  };

  render() {
    const {
      classes,
      selectedTab,
      searchResults,
      title,
      hint,
      id,
      redirect,
      showMessage,
      setTab,
      url,
      isAdmin,
    } = this.props;

    return (
      <div className={classes.root}>
        <Paper elevation={2}>
          <Tabs
            value={selectedTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Topic" />
            {searchResults && (
              <Tab
                label={
                  <Badge badgeContent={searchResults.size} color="secondary">
                    Search results
                  </Badge>
                }
              />
            )}
          </Tabs>
        </Paper>
        {selectedTab === 0 && (
          <PaddedSection>
            <EditableContent
              title={title}
              content={hint}
              isAdmin={isAdmin}
              handleSave={this.updateTopic}
              handleSaveNew={this.addNewTopic}
            />
          </PaddedSection>
        )}
        {/*selectedTab === 2 && (
          <PaddedSection>
            <AddIssue
              topicId={id}
              topicTitle={title}
              showMessage={showMessage}
              setTab={setTab}
            />
          </PaddedSection>
        )*/}
        {selectedTab === 1 && (
          <PaddedSection>
            <SearchContainer
              searchResults={searchResults}
              url={url}
              redirect={redirect}
            />
          </PaddedSection>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(HelpContent);
